"use strict";
exports.__esModule = true;
exports.SLC_SOFT_CREDIT_CHECK_CONTENT = void 0;
exports.SLC_SOFT_CREDIT_CHECK_CONTENT = {
    FEDERAL_LAW_DISCLAIMER: 'Federal law requires us to collect this info. ',
    LINK_TEXT: 'Why?',
    INCOME_LABEL: 'Annual income',
    TITLE: 'Connect to your credit profile',
    BODY: 'Flex needs access to your credit profile in order to offer you a credit line and send credit building reports.',
    AUTHORIZATION: 'By continuing, you authorize Flex to obtain your credit report in order to conduct a prequalification for credit.',
    BULLETS: [
        'This process will not affect your credit score',
        'Your income will not impact your initial credit decision',
    ]
};
